export const LINKS = {
    external: {
        facebook: "https://www.facebook.com/przystanczorsztynianka",
        instagram: "https://www.instagram.com/czorsztynianka/",
        codify: "https://codifystudio.pl/",

        mapsCzorsztyn: "https://maps.app.goo.gl/vbb4muGnBGXNeTh29",
        tourCzorsztyn: "https://tour.panoee.net/czorsztynianka-przystan-w-czorsztynie",

        mapsNiedzica: "https://maps.app.goo.gl/FuhZFBqRTVSLS9eT6",
        tourNiedzica: "https://tour.panoee.net/czorsztynianka-przystan-w-niedzicy",

        bikesRentalMaps: "https://maps.app.goo.gl/eg1zaYx7ESMogBsj6",
        housesBooking: "https://www.booking.com/hotel/pl/zamkowe-wzgorze.pl.html",
        housesRulesPdf: "https://zalewczorsztynski.com/docs/domki-regulamin.pdf",
        housesMaps: "https://maps.app.goo.gl/HRPCRyEyQMwYhMgv5",
    },

    googleMapsFrame: {
        default: "https://www.google.com/maps/d/u/0/embed?mid=1MSsHZcFj2lej3zLBJaKp4IMEOSX9vps&ehbc=2E312F&noprof=1",
        cruises: "https://www.google.com/maps/d/u/0/embed?mid=1MSsHZcFj2lej3zLBJaKp4IMEOSX9vps&ehbc=2E312F&noprof=1",
        bikesRental: "https://www.google.com/maps/d/embed?mid=1M9STj7B7GtjEiaitjFA9nxv-5ZHAFKs&ehbc=2E312F&noprof=1",
        boats: "https://www.google.com/maps/d/embed?mid=1LwipkHCGnG5AqbDMo90A1uqtkYRuPdg&ehbc=2E312F&noprof=1",
        houses: "https://www.google.com/maps/d/embed?mid=1azF_JFpAqsJP5CaxluPciJRedWVErVY&ehbc=2E312F&noprof=1",
    },

    contact: {
        phone: "tel:+48509438985",
        email: "mailto:biuro@zalewczorsztynski.com",

        bikesRentalPhone: "tel:+48570631403",
        bikesRentalEmail: "mailto:velo@zalewczorsztynski.com",

        housesPhone: "tel:+48509923730",
    },

    routes: {
        home: {
            pl: "/",
            en: "/en",
        },

        cruises: {
            pl: "/rejsy-po-jeziorze-czorsztynskim",
            en: "/cruises-on-lake-czorsztyn",
        },

        houses: {
            pl: "/domki-zamkowe-wzgorze",
            en: "/zamkowe-wzgorze-cottages",
        },

        bikes: {
            pl: "/wypozyczalnia-rowerow",
            en: "/bike-rental",
        },

        boats: {
            pl: "/wypozyczalnia-lodzi-elektrycznych",
            en: "/electric-boat-rental",
        },

        privacy: {
            pl: "/polityka-prywatnosci",
            en: "/privacy-policy",
        },
    },

    navigation: {
        home: [
            { key: "home", type: "scroll", to: "home", desktopOffset: -90, mobileOffset: -50 },
            { key: "services", type: "scroll", to: "services", desktopOffset: -90, mobileOffset: -50 },
            { key: "cruises", type: "route", to: "cruises" },
            { key: "boats", type: "route", to: "boats" },
            { key: "bikes", type: "route", to: "bikes" },
            { key: "houses", type: "route", to: "houses" },
            { key: "contact", type: "scroll", to: "address", desktopOffset: -90, mobileOffset: -50 },
        ],
        cruises: [
            { key: "homepage", type: "route", to: "home" },
            { key: "details", type: "scroll", to: "cruise-details", desktopOffset: -90, mobileOffset: -50 },
            { key: "prices", type: "scroll", to: "price-table", desktopOffset: -90, mobileOffset: -50 },
            { key: "contact", type: "scroll", to: "address", desktopOffset: -90, mobileOffset: -50 },
            { key: "gallery", type: "scroll", to: "gallery", desktopOffset: -90, mobileOffset: -50 },
        ],
        houses: [
            { key: "homepage", type: "route", to: "home" },
            { key: "details", type: "scroll", to: "houses-description", desktopOffset: -90, mobileOffset: -50 },
            { key: "booking", type: "scroll", to: "address", desktopOffset: -90, mobileOffset: -50 },
            { key: "gallery", type: "scroll", to: "gallery", desktopOffset: -90, mobileOffset: -50 },
        ],
        bikes: [
            { key: "homepage", type: "route", to: "home" },
            { key: "details", type: "scroll", to: "bikes-description", desktopOffset: -90, mobileOffset: -50 },
            { key: "equipment", type: "scroll", to: "bikes-rental", desktopOffset: -90, mobileOffset: -50 },
            { key: "prices", type: "scroll", to: "price-table", desktopOffset: -90, mobileOffset: -50 },
            { key: "contact", type: "scroll", to: "address", desktopOffset: -90, mobileOffset: -50 },
            { key: "gallery", type: "scroll", to: "gallery", desktopOffset: -90, mobileOffset: -50 },
        ],
        boats: [
            { key: "homepage", type: "route", to: "home" },
            { key: "details", to: "boats-description", desktopOffset: -100, mobileOffset: -80, },
            { key: "prices", to: "price-table", desktopOffset: -100, mobileOffset: -80, },
            { key: "contact", to: "address", desktopOffset: -100, mobileOffset: -80, },
            { key: "gallery", to: "gallery", desktopOffset: -100, mobileOffset: -80, },
        ],
    },
    sections: {
        home: "home",
        services: "services",
        address: "address",
        partners: "partners",

        cruiseDescription: "cruise-details",
        housesDescription: "houses-description",
        bikesDescription: "bikes-description",
        boatsDescription: "boats-description",

        bikesRental: "bikes-rental",

        priceTable: "price-table",
        gallery: "gallery",
        contact: "contact",
    },

    heroButtons: {
        main: [
            { key: "offer", to: "services" },
            { key: "contact", to: "address" },
        ],
        cruises: [
            { key: "description", to: "cruise-details" },
            { key: "prices", to: "price-table" },
        ],
        houses: [
            { key: "description", to: "houses-description" },
            { key: "contact", to: "address" },
        ],
        bikes: [
            { key: "description", to: "bikes-description" },
            { key: "prices", to: "price-table" },
        ],
        boats: [
            { key: "description", to: "boats-description" },
            { key: "prices", to: "price-table" },
        ],
    },

    offerItems: [
        { key: "cruises", hrefKey: "cruises" },
        { key: "boats", hrefKey: "boats" },
        { key: "bikes", hrefKey: "bikes" },
        { key: "houses", hrefKey: "houses" },
    ],
};

export const getLocalizedRoute = (routeConfig, language) => {
    const lang = language?.startsWith("en") ? "en" : "pl";

    if (typeof routeConfig === "string") {
        return routeConfig;
    }

    return routeConfig?.[lang] || routeConfig?.pl || "/";
};